import React from "react";

const Blog: React.FC = () => {
  const blogPosts = [
    {
      title: "Cronograma Académico",
      image: "/images/blog/Slide1.jpeg",
      date: "2024-03-15",
      description:
        "Cronograma de actividades académicas y eventos jurídicos programados.",
      link: "https://drive.google.com/file/d/1iYrQf24k64Lj-sCSjGxMO1og7k11JPz7/view?usp=sharing",
    },
    {
      title: "Universidad del Norte",
      image: "/images/blog/Slide1 (1).jpeg",

      date: "2024-03-10",
      description:
        "Colaboración académica con la Universidad del Norte en programas de derecho.",
      link: "https://drive.google.com/file/d/1vGsRrrw7DeNHIEIZYmO23Ct7ySBLoJDJ/view?usp=sharing",
    },
    {
      title: "RedCOLSI - EDESI XIX",
      image: "/images/blog/unad.jpg",
      date: "2024-03-05",
      description:
        "Constancia de participación en el encuentro departamental de semilleros de investigación.",
      link: "https://drive.google.com/file/d/1ZRcL1040ZHDH2HFqRaJC0Ro465kT973j/view?usp=sharing",
    },
    {
      title: "XIV Encuentro de la Red de Grupos",
      image: "/images/blog/inv+jurdica (1).jpg",
      date: "2024-02-28",
      description:
        "Reconocimiento a Andrés Felipe Soto Barrios por su participación en la red de investigación jurídica.",
      link: "https://drive.google.com/file/d/1PI8LRKdga0w_9j5URkWdKClsPajuTTj_/view?usp=sharing",
    },
    {
      title: "Semilleros de Investigación",
      image: "/images/blog/semi+inv.jpg",
      date: "2024-02-20",
      description:
        "Certificado de mérito en semilleros de investigación jurídica y reconocimiento académico.",
      link: "https://drive.google.com/file/d/1MydNGDYtnsjTelTcK0zg3IdwPaeqTcFH/view?usp=sharing",
    },
    {
      title: "Misión Jurídica",
      image: "/images/blog/mision+juridca.jpg",
      date: "2024-02-15",
      description:
        "Reconocimiento por participación en la Misión Jurídica y su aporte al derecho.",
      link: "https://drive.google.com/file/d/1p0izOFc-c6NvBcIm5lbCdp7xoU5mZ-1a/view?usp=sharing",
    },
    {
      title: "La Red RIMA y RedCOLCI",
      image: "/images/blog/cecar (1).jpg",
      date: "2024-02-10",
      description:
        "Certificación de colaboración con múltiples instituciones académicas en investigación jurídica.",
      link: "https://drive.google.com/file/d/1nzzJ-mgYFPQIqZVtFjHF6iq4u1zL662U/view?usp=sharing",
    },
    {
      title: "Resultados Preliminares ENISI 2022",
      image: "/images/blog/enisi (1).jpg",
      date: "2024-02-05",
      description:
        "Publicación de resultados preliminares del Encuentro Nacional de Investigación RedCOLSI.",
      link: "https://drive.google.com/file/d/1jXcjJZT0AyKVhUSKrF09k6Zs6yzlyipn/view?usp=sharing",
    },
  ];

  // Images for gallery section
  const galleryImages = [
    "/images/blog/andres9.jpg",
    "/images/blog/an.jpeg",
    "/images/blog/andres10.jpg",
    "/images/blog/andres14.jpg",
    "/images/blog/andres15.jpg",
    "/images/blog/andres+11.jpg",
    "/images/blog/congreso1.jpg",
    "/images/blog/edesi+XIX.jpg",
    "/images/blog/novia1.jpg",
    "/images/blog/novia2.jpg",
    "/images/blog/andrea+13.jpg",
  ];

  return (
    <div className="bg-gray-50">
      {/* Blog Section */}
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold">BLOG</h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {blogPosts.map((post, index) => (
              <div
                key={index}
                className="bg-white shadow-sm rounded-sm overflow-hidden hover:shadow-md transition-shadow"
              >
                <a
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <div className="aspect-w-16 aspect-h-9">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
                    />
                  </div>
                  <div className="p-4">
                    <div className="text-xs text-gray-500 mb-1">
                      {new Date(post.date).toLocaleDateString("es-CO", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </div>
                    <h3 className="text-lg font-medium mb-1 hover:text-blue-600 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-sm text-gray-600">{post.description}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Teeth separator for Gallery section */}
      <div className="relative">
        <div className="relative w-full h-[400px] overflow-hidden">
          <img
            src="/images/blog/law+1+banner (4).png"
            alt="Lady Justice"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h2 className="text-5xl font-bold text-white tracking-wider">
              GALERÍA
            </h2>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 48"
              preserveAspectRatio="none"
              className="w-full h-12"
              fill="white"
            >
              <path d="M0,0 L30,16 L60,0 L90,16 L120,0 L150,16 L180,0 L210,16 L240,0 L270,16 L300,0 L330,16 L360,0 L390,16 L420,0 L450,16 L480,0 L510,16 L540,0 L570,16 L600,0 L630,16 L660,0 L690,16 L720,0 L750,16 L780,0 L810,16 L840,0 L870,16 L900,0 L930,16 L960,0 L990,16 L1020,0 L1050,16 L1080,0 L1110,16 L1140,0 L1170,16 L1200,0 L1230,16 L1260,0 L1290,16 L1320,0 L1350,16 L1380,0 L1410,16 L1440,0 L1440,48 L0,48 Z"></path>
            </svg>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {galleryImages.map((image, index) => (
              <div key={index} className="relative overflow-hidden">
                <img
                  src={image}
                  alt={`Galería ${index + 1}`}
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
